/* eslint-disable max-lines */
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Checkbox, Icon, Modal, Select, Table, Tooltip } from "antd";
import {
  getAdLinkData,
  getAds,
  searchAds,
  selectAll,
  toogleAd18Old,
  toggleHideReducedPrice,
  updateAdLink,
  changeAdStatus,
  blockAd,
  getPriceChanges,
  clearPriceChanges,
  clearAdLinkData,
  getDuplicateAds,
  flagAsDuplicate,
  activateFreePromotion,
  deactivateFreePromotion,
  toggleFreeAutoPromotion,
  activateManualPromotion,
  deactivateManualPromotion,
  activateManualAutoPromotion,
  toggleManualAutoPromotion,
} from "./ad.ducks";

import {
  api,
  checkEmptyArray,
  checkEmptyObject,
  formatDate,
  isObject,
  localStorage,
  parsePriceString,
} from "../../../services";
import { mapCategoryToHr, mapModuleToHr } from "../../LanguageMapper";
import {
  AD_DUPLICATE_TAB_KEY,
  AdStatus,
  EntityType,
  LocalStorageKey,
  PageRoute,
} from "../../../models";
import styles from "./manageAdPage.scss";
import { selectCategories } from "../../../containers/App/selectors";
import { selectModules } from "../selectors";
import { getIconUrl, getImageLink } from "../../../services/asset";
import confirmModal from "../../../services/confirmModal";

export interface SearchCriteriaI {
  title: string | null;
  id: string | null;
  module: string | null;
  category: string | null;
  status: string | null;
  legalEntity: string | null;
  creatorEmail: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
  isAgent: boolean | null;
}

const defaultSearchCriteria: SearchCriteriaI = {
  title: null,
  id: null,
  module: null,
  category: null,
  status: null,
  legalEntity: null,
  creatorEmail: null,
  dateFrom: null,
  dateTo: null,
  isAgent: null
};

const FREE_PROMOTION_DURATION_OPTIONS = [
  { label: "1 dan", value: 24 },
  { label: "3 dana", value: 72 },
  { label: "7 dana", value: 168 },
  { label: "14 dana", value: 336 },
  { label: "30 dana", value: 720 },
];

const PAYMENT_METHOD_OPTIONS = [
  { label: "Kreditna kartica", value: 0 },
  { label: "Kredit", value: 1 },
  { label: "Bankovni transfer", value: 2 },
];

// eslint-disable-next-line max-lines-per-function
export default (ManageAdPage) => {
  const ManageAdPageHOC = (props) => {
    const searchCriteriaRef = useRef(defaultSearchCriteria);
    const updatingAdIdRef = useRef("");

    const [showShareLinkForm, setShowShareLinkForm] = useState(false);
    const [showPriceChanges, setShowPriceChanges] = useState(false);
    const [statusChangesAdId, setStatusChangesAdId] = useState(null);
    // Captured alongside `statusChangesAdId` so the StatusChanges modal can
    // show "Oglas objavljen: <datetime>" as an anchor for the change log.
    const [statusChangesPostedDate, setStatusChangesPostedDate] = useState(null);

    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [formValues, setFormValues] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const linkTooltip = <span>{"Ažuriraj vezu za dijeljenje"}</span>;
    const priceChangesTooltip = <span>{"Povijest promjena cijena"}</span>;
    const statusChangesTooltip = <span>Promjene statusa</span>;
    const duplicatesTooltip = <span>{"Je/nije Duplikat"}</span>;
    const statisticsTooltip = <span>{"Statistika oglasa"}</span>;
    const editTooltip = <span>{"Uredite oglas"}</span>;
    const promotedTooltip = <span>{"Je/Nije istaknut"}</span>
    const hideReducedPriceTooltip = <span>{"Sakrij/Prikaži popust"}</span>
    const markAsSpecialTooltip = <span>{"Označi kao poseban oglas"}</span>
    const freePromotionTooltip = <span>Besplatna promocija</span>;


    useEffect(() => {
      const {
        location: { search },
        getAdsAction,
        page,
        itemPerPage,
        searchAdsAction
      } = props;

      searchCriteriaRef.current = { ...defaultSearchCriteria };
      const searchParams = new URLSearchParams(search);

      if (searchParams.size > 0) {
        searchParams.forEach((value, key) => {
          searchCriteriaRef.current[key] = value;
        });
      }

      if (searchCriteriaRef.current.status === null) {
        searchCriteriaRef.current.status = AdStatus.active.toString()
      }

      setIsLoading(true);
      searchAdsAction(searchCriteriaRef.current);

      const encodedData = { ...searchCriteriaRef.current };
      if (encodedData.creatorEmail) {
        encodedData.creatorEmail = encodeURIComponent(searchCriteriaRef.current.creatorEmail);
      }

      getAdsAction(page, itemPerPage, encodedData)
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
    }, []);

    useEffect(() => {
      const { adData } = props;

      if (checkEmptyObject(adData)) {
        setShowShareLinkForm(true);
        setFormValues(adData);
      }

      setIsLoading(false);
    }, [props.adData]);

    useEffect(() => {
      const { adPriceChanges } = props;

      if (checkEmptyObject(adPriceChanges)) {
        setShowPriceChanges(true);
      }

      setIsLoading(false);
    }, [props.adPriceChanges]);



    const onPageChange = (page) => {
      const searchCriteria = searchCriteriaRef.current;
      const { getAdsAction, itemPerPage } = props;
      getAdsAction(page, itemPerPage, searchCriteria);
      setExpandedRowKeys([]);
    };

    const handleSearch = (searchCriteria) => {
      const {
        location: { search },
        history,
        searchAdsAction,
        getAdsAction,
        itemPerPage
      } = props;

      const queryString = new URLSearchParams(search);
      if (isObject(searchCriteria) && Object.keys(searchCriteria).length > 0) {
        Object.keys(searchCriteria).forEach(key => {
          if (searchCriteria[key]) {
            queryString.set(key, searchCriteria[key]);
            searchCriteria[key] = searchCriteria[key];
          } else {
            queryString.delete(key);
            searchCriteria[key] = null;
          }
        });
      }

      if (searchCriteria.dateFrom) {
        queryString.set("dateFrom", searchCriteria.dateFrom);
      } else {
        queryString.delete("dateFrom");
      }
      if (searchCriteria.dateTo) {
        queryString.set("dateTo", searchCriteria.dateTo);
      } else {
        queryString.delete("dateTo");
      }

      history.push({
        search: queryString.toString()
      });

      searchCriteriaRef.current = {
        ...defaultSearchCriteria,
        ...searchCriteria,
      };

      const encodedData = { ...searchCriteriaRef.current };
      if (encodedData.creatorEmail) {
        encodedData.creatorEmail = encodeURIComponent(searchCriteria.creatorEmail);
      }

      setIsLoading(true);

      searchAdsAction(searchCriteriaRef.current);
      getAdsAction(1, itemPerPage, encodedData)
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
    };

    const handleStatusChange = async (value, record) => {
      const { ads, page, itemPerPage, searchCriteria, getAdsAction, getDuplicateAds } = props;

      // Check if ad is promoted or awaiting payment
      let modalTitle = "Jeste li sigurni da želite promijeniti status?";

      try {
        const statusCheck = await api.Ads.paymentPromotionStatus(record.id);

        // If ad is promoted or awaiting payment, modify the confirmation message
        if (statusCheck.isPromoted || statusCheck.hasAwaitingPayment) {
          if (statusCheck.isPromoted && statusCheck.hasAwaitingPayment) {
            modalTitle = "Ovaj oglas je istaknut i čeka plaćanje, jeste li sigurni da želite promijeniti status?";
          } else if (statusCheck.isPromoted) {
            modalTitle = "Ovaj oglas je istaknut, jeste li sigurni da želite promijeniti status?";
          } else if (statusCheck.hasAwaitingPayment) {
            modalTitle = "Ovaj oglas čeka plaćanje, jeste li sigurni da želite promijeniti status?";
          }
        }
      } catch (error) {
        console.error('Error checking payment/promotion status:', error);
        // Continue with normal flow if check fails
      }

      // Show single combined confirmation modal
      Modal.confirm({
        title: modalTitle,
        // @ts-ignore
        centered: true,
        iconType: "NaN",
        okText: "Nastavi",
        cancelText: "Odustani",
        onOk() {
          // Blokiranje ide isključivo na /aditem/block endpoint; ostali statusi na change-status.
          const request = value === AdStatus.blocked
            ? props.blockAd(record.id, ads)
            : props.changeAdStatus(record.id, value, ads);

          request.then(() => {
            setIsLoading(true);
            getAdsAction(page, itemPerPage, searchCriteriaRef.current)
              .then(() => {
                if (props.searchCriteria.status === AD_DUPLICATE_TAB_KEY && expandedRowKeys.length > 0) {
                  const currentExpandedId = expandedRowKeys[0];
                  const currentExpandedAd = ads.find(ad => ad.id === currentExpandedId);
                  getDuplicateAds(currentExpandedAd.duplicateId).then(() => setIsLoading(false)).catch(() => setIsLoading(false));
                } else {
                  setIsLoading(false)
                }

              })
              .catch(() => setIsLoading(false));
          });
        }
      });
    }

    const handleShareLinkClick = (adId) => {
      updatingAdIdRef.current = adId;
      props.getAdLinkData(adId);
    };

    const handleFormSubmit = (values) => {
      if (values) {
        props.updateAdLink(updatingAdIdRef.current, values, () => {
          updatingAdIdRef.current = "";
          setShowShareLinkForm(false);
          props.clearAdLinkData();
          setFormValues({});
        });
      } else {
        updatingAdIdRef.current = "";
        setShowShareLinkForm(false);
        props.clearAdLinkData();
        setFormValues({});
      }
    };

    const handlePriceChangesClick = adId => {
      updatingAdIdRef.current = adId;
      props.getPriceChanges({ adId });
    };

    const handleStatusChangesClick = (adId, postedDate) => {
      setStatusChangesAdId(adId);
      setStatusChangesPostedDate(postedDate || null);
    };

    const handleDuplicateClick = (record) => {
      const {
        ads,
        page,
        getDuplicateAds,
        getAdsAction,
      } = props;

      const {
        duplicateId,
        id
      } = record;

      const afterFlagAsDuplicate = () => {
        const encodedData = { ...searchCriteriaRef.current };
        if (encodedData.creatorEmail) {
          encodedData.creatorEmail = encodeURIComponent(searchCriteriaRef.current.creatorEmail);
        }

        setIsLoading(true);
        getAdsAction(page, props.itemPerPage, encodedData)
          .then(() => {
            if (expandedRowKeys.length > 0) {
              let currentAd = ads.find(ad => ad.id === expandedRowKeys[0]);
              (
                ads &&
                ads.length > 0 &&
                checkEmptyObject(currentAd)
              ) && getDuplicateAds(
                currentAd.duplicateId
              ).then(
                () => setIsLoading(false)
              );
            } else {
              setIsLoading(false);
            }
          })
          .catch(() => setIsLoading(false));
      }

      // confirm if the ad is a duplicate or not
      let confirmModalInstance = confirmModal.show({
        title: "Je li ovaj oglas duplikat?",
        okText: "Je duplikat",
        cancelText: "Nije duplikat",
        iconType: "NaN",
        footer: <React.Fragment>
          <Button
            type="primary"
            onClick={() => {
              flagAsDuplicate(duplicateId, id, true, () => {
                confirmModalInstance.destroy();
                afterFlagAsDuplicate();

              });
            }}
          >Je duplikat</Button>
          <Button
            onClick={() => {
              flagAsDuplicate(duplicateId, id, false, () => {
                confirmModalInstance.destroy();
                afterFlagAsDuplicate();
              });
            }}
            type="default"
            style={{ marginLeft: "10px" }}
          >Nije duplikat</Button>
        </React.Fragment>,
      });
    };

    const handlePriceChangesPageChange = (page, cb) => {
      props.getPriceChanges(
        {
          adId: updatingAdIdRef.current,
          page: page
        },
      ).then(() => cb())
        .catch(() => cb());
    };

    const handlePriceChangesClose = () => {
      setShowPriceChanges(false);
      updatingAdIdRef.current = "";
      props.clearPriceChanges();
    };

    const handleHideReducedPrice = (record) => {
      const {
        getAdsAction,
        itemPerPage,
        page,
      } = props;

      Modal.confirm({
        title: !record.hideReducedPrice
          ? "Želite li isključiti prikaz snižene cijene za oglas korisnika {0}?".replace("{0}", record.username)
          : "Želite li prikazati snižene cijene za oglas korisnika {0}?".replace("{0}", record.username),
        // @ts-ignore
        centered: true,
        iconType: "NaN",
        onOk() {
          props.toggleHideReducedPrice(record, (success) => {
            if (success) {
              setIsLoading(true);
              getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                .then(() => setIsLoading(false))
                .catch(() => setIsLoading(false));
            }
          });
        },
      });
    };

    const handleFreePromotionClick = (record) => {
      const {
        getAdsAction,
        itemPerPage,
        page,
      } = props;

      let selectedDuration = FREE_PROMOTION_DURATION_OPTIONS[0].value;
      let enableAutoRenewal = false;
      const isPromoted = record.isPromoted;
      const hasAutoPromotion = record.autoPromotionStatus === 1;

      const modalInstance = confirmModal.show({
        title: "Besplatna promocija",
        children: isPromoted ? (
          <div style={{ marginTop: 16 }}>
            <p>Oglas je trenutno promoviran.</p>
            <p>Auto-obnova: {hasAutoPromotion ? `${record.autoPromotionDays} dana` : "nije uključena"}</p>
            <div style={{ marginTop: 16 }}>
              <Checkbox
                defaultChecked={hasAutoPromotion}
                onChange={(e) => {
                  props.toggleFreeAutoPromotion(record.id, e.target.checked, (success) => {
                    if (success) {
                      setIsLoading(true);
                      getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                        .then(() => setIsLoading(false))
                        .catch(() => setIsLoading(false));
                    }
                  });
                }}
              >
                Auto-obnova
              </Checkbox>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: 16 }}>
            <div style={{ marginBottom: 12 }}>
              <span style={{ marginRight: 8 }}>Trajanje:</span>
              <Select
                defaultValue={selectedDuration}
                style={{ width: 120 }}
                onChange={(value) => { selectedDuration = value; }}
                getPopupContainer={() => document.body}
                dropdownStyle={{ zIndex: 9999 }}
              >
                {FREE_PROMOTION_DURATION_OPTIONS.map(option => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div>
              <Checkbox
                defaultChecked={enableAutoRenewal}
                onChange={(e) => { enableAutoRenewal = e.target.checked; }}
              >
                Uključi auto-obnovu
              </Checkbox>
            </div>
          </div>
        ),
        footer: isPromoted ? (
          <React.Fragment>
            <Button
              type="danger"
              onClick={() => {
                props.deactivateFreePromotion(record.id, (success) => {
                  modalInstance.destroy();
                  if (success) {
                    setIsLoading(true);
                    getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                      .then(() => setIsLoading(false))
                      .catch(() => setIsLoading(false));
                  }
                });
              }}
            >
              Deaktiviraj
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              onClick={() => modalInstance.destroy()}
            >
              Zatvori
            </Button>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Button
              type="primary"
              onClick={() => {
                props.activateFreePromotion(record.id, selectedDuration, (success) => {
                  if (success) {
                    if (enableAutoRenewal) {
                      props.toggleFreeAutoPromotion(record.id, true, () => {
                        modalInstance.destroy();
                        setIsLoading(true);
                        getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                          .then(() => setIsLoading(false))
                          .catch(() => setIsLoading(false));
                      });
                    } else {
                      modalInstance.destroy();
                      setIsLoading(true);
                      getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                        .then(() => setIsLoading(false))
                        .catch(() => setIsLoading(false));
                    }
                  } else {
                    modalInstance.destroy();
                  }
                });
              }}
            >
              Aktiviraj
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              onClick={() => modalInstance.destroy()}
            >
              Odustani
            </Button>
          </React.Fragment>
        ),
      });
    };

    const handleManualPromotionClick = (record) => {
      const {
        getAdsAction,
        itemPerPage,
        page,
      } = props;

      let selectedDuration = FREE_PROMOTION_DURATION_OPTIONS[0].value;
      let selectedPaymentMethod = PAYMENT_METHOD_OPTIONS[0].value;
      let enableAutoRenewal = false;
      const isPromoted = record.isPromoted && !record.hasFreePromotion;
      const hasAutoPromotion = record.autoPromotionStatus === 1;

      const setButtonsLoading = (loading) => {
        modalInstance.update({
          footer: (
            <React.Fragment>
              <Button
                type={isPromoted ? "danger" : "primary"}
                loading={loading}
                disabled={loading}
                onClick={handleOkClick}
              >
                {isPromoted ? "Deaktiviraj" : "Aktiviraj"}
              </Button>
              <Button
                style={{ marginLeft: "10px" }}
                disabled={loading}
                onClick={() => modalInstance.destroy()}
              >
                {isPromoted ? "Zatvori" : "Odustani"}
              </Button>
            </React.Fragment>
          ),
        });
      };

      const handleOkClick = () => {
        setButtonsLoading(true);

        if (isPromoted) {
          props.deactivateManualPromotion(record.id, (success) => {
            if (success) {
              getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                .then(() => modalInstance.destroy())
                .catch(() => setButtonsLoading(false));
            } else {
              setButtonsLoading(false);
            }
          });
        } else {
          props.activateManualPromotion(record.id, selectedDuration, selectedPaymentMethod, (success) => {
            if (success) {
              if (enableAutoRenewal) {
                props.activateManualAutoPromotion(record.id, (autoSuccess) => {
                  if (autoSuccess) {
                    getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                      .then(() => modalInstance.destroy())
                      .catch(() => setButtonsLoading(false));
                  } else {
                    setButtonsLoading(false);
                  }
                });
              } else {
                getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                  .then(() => modalInstance.destroy())
                  .catch(() => setButtonsLoading(false));
              }
            } else {
              setButtonsLoading(false);
            }
          });
        }
      };

      const modalInstance = confirmModal.show({
        title: "Plaćena promocija",
        footer: (
          <React.Fragment>
            <Button
              type={isPromoted ? "danger" : "primary"}
              onClick={handleOkClick}
            >
              {isPromoted ? "Deaktiviraj" : "Aktiviraj"}
            </Button>
            <Button
              style={{ marginLeft: "10px" }}
              onClick={() => modalInstance.destroy()}
            >
              {isPromoted ? "Zatvori" : "Odustani"}
            </Button>
          </React.Fragment>
        ),
        children: isPromoted ? (
          <div style={{ marginTop: 16 }}>
            <p>Oglas je trenutno promoviran.</p>
            <p>Auto-obnova: {hasAutoPromotion ? `${record.autoPromotionDays} dana` : "nije uključena"}</p>
            <div style={{ marginTop: 16 }}>
              <Checkbox
                defaultChecked={hasAutoPromotion}
                onChange={(e) => {
                  props.toggleManualAutoPromotion(record.id, e.target.checked, (success) => {
                    if (success) {
                      setIsLoading(true);
                      getAdsAction(page, itemPerPage, searchCriteriaRef.current)
                        .then(() => setIsLoading(false))
                        .catch(() => setIsLoading(false));
                    }
                  });
                }}
              >
                Auto-obnova
              </Checkbox>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: 16 }}>
            <div style={{ marginBottom: 12 }}>
              <span style={{ marginRight: 8 }}>Trajanje:</span>
              <Select
                defaultValue={selectedDuration}
                style={{ width: 120 }}
                onChange={(value) => { selectedDuration = value; }}
                getPopupContainer={() => document.body}
                dropdownStyle={{ zIndex: 9999 }}
              >
                {FREE_PROMOTION_DURATION_OPTIONS.map(option => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <span style={{ marginRight: 8 }}>Način plaćanja:</span>
              <Select
                defaultValue={selectedPaymentMethod}
                style={{ width: 150 }}
                onChange={(value) => { selectedPaymentMethod = value; }}
                getPopupContainer={() => document.body}
                dropdownStyle={{ zIndex: 9999 }}
              >
                {PAYMENT_METHOD_OPTIONS.map(option => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div>
              <Checkbox
                defaultChecked={enableAutoRenewal}
                onChange={(e) => { enableAutoRenewal = e.target.checked; }}
              >
                Uključi auto-obnovu
              </Checkbox>
            </div>
          </div>
        ),
      });
    };

    const handleTabChange = (status) => {
      const {
        location: { search },
        history,
        itemPerPage,
        searchCriteria,
        searchAdsAction,
      } = props;
      const queryString = new URLSearchParams(search);
      queryString.set("status", status);


      if (searchCriteria.dateFrom) {
        queryString.set("dateFrom", searchCriteria.dateFrom);
      } else {
        queryString.delete("dateFrom");
      }
      if (searchCriteria.dateTo) {
        queryString.set("dateTo", searchCriteria.dateTo);
      } else {
        queryString.delete("dateTo");
      }

      searchCriteriaRef.current = {
        ...searchCriteria,
        status,
      };

      history.push({
        search: queryString.toString(),
      });

      const encodedData = { ...searchCriteriaRef.current };
      if (encodedData.creatorEmail) {
        encodedData.creatorEmail = encodeURIComponent(searchCriteriaRef.current.creatorEmail);
      }

      setIsLoading(true);
      searchAdsAction(searchCriteriaRef.current);
      props.getAdsAction(1, itemPerPage, encodedData)
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
    };

    const columns = [
      {
        title: "Kod, cijena i slika",
        dataIndex: "thumbnailImage",
        class: "ad-table-row",
        key: "thumbnailImage",
        width: 140,
        render: (value, record) => (
          <div>

            <span className={styles.adCode}>
              {record.code}
            </span>
            <img
              alt={record.Name}
              src={getImageLink(value)}
              style={{ maxHeight: "100px", width: "100%", borderRadius: "10px" }}
            />
            <span className={styles.price}>
              {record.price ? parsePriceString(record.price) : null}
            </span>
          </div>
        ),
      },
      {
        title: "Naslov",
        dataIndex: "title",
        key: "title",
        width: 180,
        render: (value, record) => (
          <Link
            title={value}
            className={styles.title}
            target="_blank"
            to={`/${mapModuleToHr(record.module)}/${mapCategoryToHr(
              record.category,
              record.module
            )}${PageRoute.details}/${record.smartLink}/${record.code}`}
          >
            {value}
          </Link>
        ),
      },
      {
        title: "Korisnik",
        dataIndex: "creator",
        key: "creator",
        width: 120,
        render: (value, record) => (
          <Link
            title={record.username}
            className={styles.username}
            target="_blank"
            to={`/admin/user/profile/${record.creatorId}`}
          >
            {record.username}
          </Link>
        ),
      },
      {
        title: "Datum objave",
        key: "dateOfPublication",
        dataIndex: "postedDate",
        width: 105,
        render: (value) => formatDate(value),
      },
      {
        title: () => {
          if (searchCriteriaRef.current.status === AdStatus.paused.toString()) {
            return "Datum deaktivacije"
          } else if (searchCriteriaRef.current.status === AdStatus.sold.toString()) {
            return "Datum prodaje"
          } else if (searchCriteriaRef.current.status === AdStatus.deleted.toString()) {
            return "Datum brisanja"
          } else if (searchCriteriaRef.current.status === AdStatus.blocked.toString()) {
            return "Datum blokiranja"
          } else {
            return "Istječe"
          }
        },
        dataIndex: "statusDate",
        key: "statusDate",
        width: 105,
        render: (value, record) => value ? formatDate(value) : null,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 165,
        render: (value, record) => (
          <Select
            value={value}
            style={{ width: 130 }}
            onChange={val => handleStatusChange(
              val,
              record
            )}
          >
            {Object.keys(AdStatus).map(key => (
              AdStatus[key] === AdStatus.all || AdStatus[key] === AdStatus.expireSoon ? null : (
                <Select.Option key={AdStatus[key]} value={AdStatus[key]}>
                  {{
                    active: "Aktivan",
                    paused: "Pauziran",
                    sold: "Prodano",
                    deleted: "Obrisano",
                    blocked: "Blokiran",
                    expired: "Istekao",
                    pending: "Čeka odobrenje",
                    duplicate: "Duplikat",
                  }[key] || key}
                </Select.Option>
              )
            ))}
          </Select>
        )
      },
      {
        title: "Kategorija",
        dataIndex: "fullCategoryPathList",
        key: "fullCategoryPathList",
        width: 180,
        render: (value, record) => {
          return (
            <span>
              {value && value.join(" > ")}
            </span>
          )
        }
      },

      {
        title: "Tip prodavača",
        dataIndex: "legalEntity",
        key: "legalEntity",
        width: 100,
        render: value => <React.Fragment>{value === EntityType.LegalEntity ? "Pravna osoba" : "Fizička osoba"}</React.Fragment>
      },
      {
        title: "18+",
        dataIndex: "is18Old",
        key: "18-old",
        width: 80,
        render: (value, { id }) => (
          <Checkbox
            onChange={e => props.toogleAd18Old(e.target.checked, id)}
            defaultChecked={value}
          />
        )
      },
      {
        title: "Akcije",
        key: "block",
        align: "center",
        dataIndex: "id",
        fixed: "right",
        width: 90,
        render: (value, record) => (
          <React.Fragment>
            <div
              style={{
                display: "inline-block",
                marginTop: "5px",
              }}
            >
              <Tooltip placement="topLeft" title={statisticsTooltip}>
                <Button
                  type="primary"
                  onClick={() =>
                    window.open(`/oglasi${PageRoute.statistics}/${value}`)
                  }
                >
                  <Icon type="bar-chart" className="manage-ad-icon" />
                </Button>
              </Tooltip>
            </div>

            <React.Fragment>
              <div
                style={{
                  display: "inline-block",
                  marginTop: "5px",
                }}
              >
                <Tooltip placement="topLeft" title={promotedTooltip}>
                  <Button
                    type={record.isPromoted && !record.hasFreePromotion ? "primary" : "default"}
                    disabled={record.isPromoted && record.hasFreePromotion}
                    onClick={() => !(record.isPromoted && record.hasFreePromotion) && handleManualPromotionClick(record)}
                  >
                    <img
                      alt={"Istaknuto"}
                      src={getIconUrl(
                        record.isPromoted && record.hasFreePromotion
                          ? "promote-small-gray.svg"
                          : record.isPromoted
                            ? "promote-small-white.svg"
                            : "promote-small-red.svg"
                      )}
                      style={{
                        width: "14px",
                        marginRight: "0px",
                      }}
                    />
                  </Button>
                </Tooltip>
              </div>
              <div
                style={{
                  display: "inline-block",
                  marginTop: "5px",
                }}
              >
                <Tooltip placement="topLeft" title={freePromotionTooltip}>
                  <Button
                    type={record.hasFreePromotion ? "danger" : "default"}
                    disabled={record.isPromoted && !record.hasFreePromotion}
                    onClick={() => !(record.isPromoted && !record.hasFreePromotion) && handleFreePromotionClick(record)}
                  >
                    <Icon type="gift" className="manage-ad-icon" />
                  </Button>
                </Tooltip>
              </div>
              <div
                style={{
                  display: "inline-block",
                  marginTop: "5px",
                }}
              >
                <Tooltip placement="topLeft" title={linkTooltip}>
                  <Button
                    type="primary"
                    onClick={() => handleShareLinkClick(value)}
                  >
                    <Icon type="link" className="manage-ad-icon" />
                  </Button>
                </Tooltip>
              </div>
              <div
                style={{
                  display: "inline-block",
                  marginTop: "5px",
                }}
              >
                <Tooltip placement="topLeft" title={editTooltip}>
                  <Button
                    onClick={async () => {
                      // Check if ad is promoted or awaiting payment
                      try {
                        const statusCheck = await api.Ads.paymentPromotionStatus(value);

                        // If ad is promoted or awaiting payment, show warning modal first
                        if (statusCheck.isPromoted || statusCheck.hasAwaitingPayment) {
                          let warningMessage = "Ovaj oglas je istaknut, da li sigurno želiš nastaviti?";

                          if (statusCheck.isPromoted && statusCheck.hasAwaitingPayment) {
                            warningMessage = "Ovaj oglas je istaknut i čeka plaćanje, da li sigurno želiš nastaviti?";
                          } else if (statusCheck.hasAwaitingPayment) {
                            warningMessage = "Ovaj oglas čeka plaćanje, da li sigurno želiš nastaviti?";
                          }

                          Modal.confirm({
                            title: warningMessage,
                            // @ts-ignore
                            centered: true,
                            iconType: "NaN",
                            okText: "Nastavi",
                            cancelText: "Odustani",
                            onOk() {
                              localStorage.getItem(LocalStorageKey.savedForm) &&
                                localStorage.removeItem(LocalStorageKey.savedForm);
                              window.open(`/oglasi${PageRoute.editAd}/${value}`);
                            },
                            onCancel() {
                              // User clicked Cancel, do nothing
                            }
                          });
                          return;
                        }
                      } catch (error) {
                        console.error('Error checking payment/promotion status:', error);
                        // Continue with normal flow if check fails
                      }

                      // If not promoted or awaiting payment, proceed directly
                      localStorage.getItem(LocalStorageKey.savedForm) &&
                        localStorage.removeItem(LocalStorageKey.savedForm);
                      window.open(`/oglasi${PageRoute.editAd}/${value}`);
                    }}
                    target="_blank"
                    type="primary"
                  >
                    <Icon type="form" className="manage-ad-icon" />
                  </Button>
                </Tooltip>
              </div>
              <div
                style={{
                  display: "inline-block",
                  marginTop: "5px",
                }}
              >
                <Tooltip
                  placement="topLeft"
                  title={hideReducedPriceTooltip}
                >
                  <Button
                    onClick={() => handleHideReducedPrice(record)}
                    type={record.hideReducedPrice ? "primary" : "default"}
                  >
                    <Icon type="percentage" className="ad-percentage-icon" />
                  </Button>
                </Tooltip>
              </div>

              {record.priceChanges && record.priceChanges.length > 0 && (
                <div
                  style={{
                    display: "inline-block",
                    marginTop: "5px",
                  }}
                >
                  <Tooltip placement="topLeft" title={priceChangesTooltip}>
                    {" "}
                    { }
                    <Button
                      type="default"
                      onClick={() => handlePriceChangesClick(value)}
                    >
                      <Icon type="euro" className="manage-ad-icon" />
                    </Button>
                  </Tooltip>
                </div>
              )}

              <div
                style={{
                  display: "inline-block",
                  marginTop: "5px",
                }}
              >
                <Tooltip placement="topLeft" title={statusChangesTooltip}>
                  {" "}
                  { }
                  <Button
                    type="default"
                    onClick={() => handleStatusChangesClick(value, record.postedDate)}
                  >
                    <Icon type="history" className="manage-ad-icon" />
                  </Button>
                </Tooltip>
              </div>

              {props.searchCriteria.status === AD_DUPLICATE_TAB_KEY && (
                <div
                  style={{
                    display: "inline-block",
                    marginTop: "5px",
                  }}
                >
                  <Tooltip placement="topLeft" title={duplicatesTooltip}>
                    <Button
                      type={record.isDuplicate ? "primary" : "default"}
                      onClick={() => handleDuplicateClick(record)}
                    >
                      <Icon type="copy" className="manage-ad-icon" />
                    </Button>
                  </Tooltip>
                </div>
              )}
            </React.Fragment>

          </React.Fragment>
        ),
      },
    ];

    const filteredColumns = columns.filter(column => {
      // skip legalEntity column on Pending tab

      // skip legalEntity column on Duplicates tab
      // skip expirationDate column on Duplicates tab
      // skip 18Old column on Duplicates tab
      if (
        (column.key === 'legalEntity' && props.searchCriteria.status === AD_DUPLICATE_TAB_KEY) ||
        (column.key === 'statusDate' && props.searchCriteria.status === AD_DUPLICATE_TAB_KEY) ||
        (column.key === '18-old' && props.searchCriteria.status === AD_DUPLICATE_TAB_KEY)
      ) {
        return false;
      } else {
        return true;
      }
    });

    if (props.searchCriteria.status === AD_DUPLICATE_TAB_KEY) {
      filteredColumns.unshift({
        title: "Broj duplikata",
        dataIndex: "duplicateCount",
        key: "duplicateCount",
        width: 100,
        render: (value, record) => <span></span>
      });
    }

    const handleExpandedRowsChange = (expanded) => {
      const {
        ads,
        getDuplicateAds,
        getAdsAction,
        page,
        itemPerPage
      } = props;

      const currentExpandedId = expanded[expanded.length - 1];
      const currentExpandedAd = ads.find(ad => ad.id === currentExpandedId);

      setExpandedRowKeys(currentExpandedId ? [currentExpandedId] : []);

      if (currentExpandedAd) {
        setIsLoading(true);
        getDuplicateAds(currentExpandedAd.duplicateId).then(() => setIsLoading(false)).catch(() => setIsLoading(false));
      }
    };

    const nestedColumns = filteredColumns.map(col => col.fixed ? { ...col, fixed: undefined } : col);

    const expandedRowRender = props.searchCriteria.status === AD_DUPLICATE_TAB_KEY ? record => {
      const { adDuplicates } = props;

      return (
        <Table
          dataSource={adDuplicates}
          bordered={false}
          columns={nestedColumns}
          pagination={adDuplicates && adDuplicates.length < 10 ? false : {
            pageSize: 10,
            total: adDuplicates ? adDuplicates.length : 0,

            showSizeChanger: false,
            position: "bottom",
          }} />
      );
    } : null;

    const expandedIcon = props.searchCriteria.status === AD_DUPLICATE_TAB_KEY ? ({ expanded, onExpand, record }) => {
      return (
        <React.Fragment>
          <Button
            onClick={e => onExpand(record, e)}
            type={!record.reviewed ? "primary" : "default"}
            style={{ width: "100%" }}
          >
            <span style={{ marginRight: 5 }}>{record.duplicateCount}</span>
            <Icon type={expanded ? "caret-up" : "caret-down"} />
          </Button>
        </React.Fragment>
      );
    } : null;

    return (
      <React.Fragment>
        <ManageAdPage
          {...props}
          onPageChange={onPageChange}
          onSearch={handleSearch}
          columns={filteredColumns}
          expandedRowRender={expandedRowRender}
          onExpandedRowsChange={handleExpandedRowsChange}
          expandedRowKeys={expandedRowKeys}
          expandedIcon={expandedIcon}
          showShareLinkForm={showShareLinkForm}
          priceChangeValues={props.adPriceChanges}
          showPriceChanges={showPriceChanges}
          onPriceChangesClose={handlePriceChangesClose}
          onPriceChangesPageChange={handlePriceChangesPageChange}
          formValues={formValues}
          onFormSubmit={handleFormSubmit}
          onTabChange={handleTabChange}
          isLoading={isLoading}
          statusChangesAdId={statusChangesAdId}
          setStatusChangesAdId={setStatusChangesAdId}
          statusChangesPostedDate={statusChangesPostedDate}
          setStatusChangesPostedDate={setStatusChangesPostedDate}
        />
      </React.Fragment>
    );
  };

  ManageAdPageHOC.defaultProps = {
    modules: [],
    categories: [],
    adData: {},
    adPriceChanges: {},
  };

  return connect(
    (state) => ({
      ...selectAll(state),
      modules: selectModules(state),
      categories: selectCategories(state),
    }),
    {
      getAdsAction: getAds,
      getDuplicateAds,
      flagAsDuplicate,
      searchAdsAction: searchAds,
      getAdLinkData,
      clearAdLinkData,
      updateAdLink,
      getPriceChanges,
      clearPriceChanges,
      toogleAd18Old,
      toggleHideReducedPrice,
      changeAdStatus,
      blockAd,
      activateFreePromotion,
      deactivateFreePromotion,
      toggleFreeAutoPromotion,
      activateManualPromotion,
      deactivateManualPromotion,
      activateManualAutoPromotion,
      toggleManualAutoPromotion,
    }
  )(ManageAdPageHOC);
};



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdPage/handleManageAdPage.tsx